import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {loginPath} from "../../../../app-routing.constants";
import {Router} from "@angular/router";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    imports: [CommonModule, TranslateModule]
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) {
  }

  logout() {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigateByUrl('/' + loginPath);
      },
      error: () => {
        this.router.navigateByUrl('/' + loginPath);
      }
    });;
  }

  ngOnInit() {
    return;
  }

}
